import BaseFormPresenter from "../../../base/BaseFormPresenter";

class FollowUpViewPresenter extends BaseFormPresenter {
    
}

export default FollowUpViewPresenter;
